export default __webpack_public_path__ + "static/media/sliders-h-solid.af63a635.svg";